import { z } from "zod";

export const teamManagementSchema = z.object({
  dept_id: z.number({ required_error: "Department is required" }),
  hod_id: z.number({ required_error: "HOD is required" }),
  team_name: z
    .string()
    .min(1, "Team name is required")
    .max(100, "Team name must be under 100 characters"),
  team_members: z
    .array(z.number())
    .min(1, "At least one team member must be selected"),
});
